var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "20px",
    viewBox: "0 0 31 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logos/ cc/visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "6.59574468e-05 0.216444444 30.954995 0.216444444 30.954995 19.9999333 6.59574468e-05 19.9999333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.4252 0.25 7.3748 0.25 7.3748 9.6 0.4252 9.6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos/-cc/visa",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.954995,17.7777111 C30.954995,18.9999333 29.9656333,19.9999333 28.7564135,19.9999333 L2.19864752,19.9999333 C0.98942766,19.9999333 6.59574462e-05,18.9999333 6.59574462e-05,17.7777111 L6.59574462e-05,2.4386 C6.59574462e-05,1.21637778 0.98942766,0.216377778 2.19864752,0.216377778 L28.7564135,0.216377778 C29.9656333,0.216377778 30.954995,1.21637778 30.954995,2.4386 L30.954995,17.7777111 Z",
    id: "Fill-1",
    fill: "#050302",
    mask: "url(#mask-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(1.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(13.600000, 0.550000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15,0.25 C6.2404,0.25 7.3748,0.6996 7.3748,0.6996 L6.9748,2.65 C6.9748,2.65 6.1124,2.0748 5.35,2.0748 C4.1748,2.0748 3.75,2.4596 3.75,2.9748 C3.75,3.9844 7.0252,4.1628 7.0252,6.4252 C7.0252,8.306 4.6908,9.6004 2.9996,9.6004 C1.3092,9.6004 0.4252,9.1004 0.4252,9.1004 L0.85,7.2004 C0.85,7.2004 1.734,7.7252 3.0996,7.7252 C4.4628,7.7252 4.65,7.1436 4.65,6.9004 C4.65,5.4564 1.4004,5.8596 1.4004,3.05 C1.4004,1.4972 2.6684,0.25 5.15,0.25",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.17496,0.97504 L10.69976,0.97504 L7.09976,9.87504 L4.49976,9.87504 L2.59976,2.67504 C2.59976,2.67504 4.59656,3.69344 5.82456,6.45024 C5.87816,6.78464 6.02456,7.32464 6.02456,7.32464 L8.17496,0.97504 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    points: "11.62496 0.97504 14.02496 0.97504 12.60016 9.87504 10.22496 9.87504"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    points: "26.92504 0.97504 24.44984 0.97504 20.57544 9.87504 22.92504 9.87504 23.40024 8.59984 26.34984 8.59984 26.60024 9.87504 28.74984 9.87504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1 L3.6496,1 C4.5816,1 4.9248,1.8752 4.9248,1.8752 L5.7248,5.9248 C4.644,2.4376 0,1 0,1",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#050302",
    points: "25.35 3.55 24.05 6.8996 25.9996 6.8996"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.82570f1c.svg";
export { ForwardRef as ReactComponent };